// Oferta Amazon manual (SiteStripe): o destino clicável é o link oficial, DIRETO. Nunca /r/, /api/go/deal nem
// redirect do Super Vitrine (compra que passa por site intermediário sem ação do cliente nele não paga comissão).
// O clique no site é só contado por beacon, depois que o navegador já seguiu o link; nada aqui atrasa, troca o
// href ou bloqueia a navegação. Sem JavaScript, o <a href> continua funcionando.
import { API } from '../config/apiBase';

// Cópia de backend/amazon_sitestripe.LINK_RE_STR; tests/test_amazon_sitestripe.py trava as cópias iguais.
export const SITESTRIPE_RE = /^https:\/\/link\.amazon\/[A-Za-z0-9_-]{4,64}(?:\?[A-Za-z0-9._~=&%-]{1,512})?$/;
export const REL_AMAZON = 'sponsored nofollow noopener';
export const ROTA_CLIQUE = '/analytics/amazon-manual-click';

export const ehAmazonManual = (deal) => !!deal && deal.price_mode === 'sem_preco' && deal.source === 'amazon_manual_sitestripe';

/** O link oficial exato, ou '' (aí não há CTA para a Amazon). */
export const linkAmazonDireto = (deal) => {
    const link = deal && deal.affiliate_link;
    return ehAmazonManual(deal) && typeof link === 'string' && SITESTRIPE_RE.test(link) ? link : '';
};

// Sessão anônima da coleta do site (`sv-sessao`), só se JÁ existir: o beacon não cria nada no localStorage.
function sessaoExistente() {
    try {
        const s = JSON.parse(window.localStorage.getItem('sv-sessao') || 'null');
        return s && /^[a-f0-9]{32}$/.test(s.id || '') ? s.id : null;
    } catch (_) {
        return null;
    }
}

/** Conta o clique (deal, superfície, sessão anônima). Nunca lança, nunca espera, nunca impede a navegação. */
export function registrarCliqueAmazon(dealId, superficie) {
    try {
        const url = `${API}${ROTA_CLIQUE}`;
        const corpo = JSON.stringify({ deal_id: dealId, surface: superficie, session_id: sessaoExistente() });
        // text/plain: não dispara preflight e o sendBeacon aceita em qualquer navegador.
        if (typeof navigator !== 'undefined' && navigator.sendBeacon
            && navigator.sendBeacon(url, new Blob([corpo], { type: 'text/plain;charset=UTF-8' }))) return;
        const p = fetch(url, { method: 'POST', body: corpo, keepalive: true, credentials: 'omit',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
        if (p && p.catch) p.catch(() => {});
    } catch (_) { /* a navegação nunca depende do analytics */ }
}
